import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { prop } from "../../../decorators/prop/index.js";
import { html, nothing } from "lit";
import { state } from "lit/decorators.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let DsfVisible = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.dsf_margin = "0px";
    this.dsf_threshold = 0;
    this.dsf_render_placeholder = false;
    this.isVisible = false;
  }
  async createObserver() {
    var _a;
    if (this.observer) {
      (_a = this.observer) == null ? void 0 : _a.disconnect();
    }
    await this.updateComplete;
    this.observer = new IntersectionObserver(
      ([entry]) => {
        const { isIntersecting } = entry;
        if (this.isVisible !== isIntersecting) {
          this.isVisible = isIntersecting;
          const event = isIntersecting ? "visible" : "hidden";
          this.emit({ name: event, payload: entry });
        }
      },
      {
        rootMargin: this.dsf_margin,
        threshold: this.dsf_threshold,
        root: this.dsf_parent
      }
    );
    this.observer.observe(this);
  }
  async updated(_changedProperties) {
    if (_changedProperties.has("dsf_margin") || _changedProperties.has("dsf_threshold")) {
      await this.createObserver();
    }
  }
  async connectedCallback() {
    super.connectedCallback();
    await this.createObserver();
  }
  disconnectedCallback() {
    var _a;
    super.disconnectedCallback();
    (_a = this.observer) == null ? void 0 : _a.disconnect();
    this.observer = void 0;
  }
  render() {
    if (this.isVisible) {
      if (this.dsf_renderer) {
        try {
          return this.dsf_renderer();
        } catch (e) {
          if (process.env.NODE_ENV !== "production") {
            console.error("Failed to run renderer fn", e);
            this.emit({ name: "render-error", payload: e });
          }
        }
      }
      return html`<slot></slot>`;
    } else if (this.dsf_render_placeholder) {
      return html`<slot name="placeholder"></slot>`;
    }
    return nothing;
  }
};
__decorateClass([
  prop({ type: String })
], DsfVisible.prototype, "dsf_margin", 2);
__decorateClass([
  prop({ type: String })
], DsfVisible.prototype, "dsf_threshold", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfVisible.prototype, "dsf_render_placeholder", 2);
__decorateClass([
  prop({ type: Function })
], DsfVisible.prototype, "dsf_renderer", 2);
__decorateClass([
  prop({ type: HTMLElement })
], DsfVisible.prototype, "dsf_parent", 2);
__decorateClass([
  state()
], DsfVisible.prototype, "isVisible", 2);
DsfVisible = __decorateClass([
  defineElement("dsf-visible")
], DsfVisible);
export {
  DsfVisible
};
